import { connect } from "react-redux";
import TopLevelRouter from "./TopLevelRouter";
import { DRAWER_STATE } from "./actions/drawer";

const mapStateToProps = (state, ownProps) => {
  return {
    indent: state.ui.geometry.drawer === DRAWER_STATE.DOCKED ? 250 : 0
  };
};

const TopLevelRouterContainer = connect(mapStateToProps)(TopLevelRouter);

export default TopLevelRouterContainer;



// WEBPACK FOOTER //
// ./src/TopLevelRouterContainer.js